import { getAccountById } from '@/api/account'
import { addActivity, getActivity, updateActivity, delActivity, getActivityById, updateActivityStatus } from '@/api/activety'
import { message } from 'ant-design-vue'

export enum ActivityTypeEnum {
  'DISCOUNT' = 'DISCOUNT',
  'GROUP' = 'GROUP'
}

export class ActivityController {
  static pingtuaType = [{ title: '折扣', key: 'DISCOUNT' }, { title: '折扣团', key: 'GROUP' }]

  static async pingtuanPage (params: COMMON.API.QueryParams) {
    const { code, data } = await getActivity(params)
    return {
      code,
      data: data.records,
      sum: data.total
    }
  }

  static async addPingtuan (data: ACTIVITY.Detail) {
    const { code, msg } = await addActivity(data)
    code === 0 ? message.success('新增活动成功') : message.error(msg)
  }

  static async updatePingtuan (data: ACTIVITY.Detail) {
    const { code, msg } = await updateActivity(data)
    code === 0 ? message.success('修改活动成功') : message.error(msg)
  }

  static async getPingtuanById (id: string) {
    return await getActivityById(id)
  }

  static async delActivity (id: string) {
    const { code, msg } = await delActivity(id)
    code === 0 ? message.success('删除成功') : message.error(msg)
  }

  static async updateActivityStatus (params: {activityId: number, status: 0 | 1}) {
    const { code, msg } = await updateActivityStatus(params)
    code === 0 ? message.success('修改成功') : message.error(msg)
  }
}
